<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M35.2676 80.8599C35.4959 81.6014 36.0034 82.8222 37.1763 83.6427C38.4591 84.542 39.9055 84.5223 40.6921 84.4377"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M32.6621 80.1071C32.8454 81.0995 33.398 83.2564 35.2757 84.9311C37.2605 86.6988 39.6119 86.9357 40.6184 86.9723"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M61.7924 75.7313L51.1267 77.7556C49.9115 78.0207 49.8016 79.7095 50.9744 80.1324C65.5055 85.3511 68.5956 89.2841 68.4856 92.0048C68.3813 94.5789 63.2979 99.183 58.7277 103.57C53.5429 108.552 47.7434 111.893 51.2902 115.442C55.9788 120.131 75.6158 106.527 74.2146 99.4085C73.8904 97.762 72.3679 96.6878 71.4178 96.1324"
            class="accent-stroke"
            stroke-width="6.20264"
            stroke-miterlimit="10" />
        <path
            d="M34.1953 32.7894L63.2039 26.1836"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M34.8418 35.6257L63.8533 29.0199"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M35.4727 38.3915L64.4813 31.7856"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M36.1836 41.5182L43.1531 39.9309"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M56.0467 77.4597L41.7468 80.7161C39.9057 81.1362 38.0703 79.9831 37.6502 78.1392L26.477 29.0763C26.0569 27.2352 27.21 25.3998 29.0539 24.9797L64.2511 16.9642C66.0921 16.5441 67.9276 17.6973 68.3476 19.5411L76.7043 56.2044"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.1418 74.8885L42.4376 77.7417C41.3493 77.9898 40.2667 77.3075 40.0186 76.2192L29.4318 29.736C29.1837 28.6478 29.866 27.5651 30.9543 27.317"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.9534 59.9006C57.927 58.7418 59.3789 56.9882 60.3093 54.6453C61.2397 52.3024 61.423 49.8918 60.8591 47.4164L59.5368 41.6141L51.5411 40.5286L44.8027 44.9692L46.125 50.7714C46.6889 53.2469 47.8984 55.3388 49.7508 57.0502C51.6031 58.7588 53.6725 59.7089 55.9534 59.9006Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M42.3971 70.2619C42.8454 67.341 43.1922 64.3806 42.9638 61.4344C42.9046 60.6788 42.8087 59.9232 42.5663 59.2071C42.4563 58.88 42.242 58.5107 41.8953 58.5079C41.509 58.5079 41.3004 58.959 41.244 59.3424C41.1368 60.0811 41.2383 60.8339 41.3765 61.5697C41.5428 62.455 41.7599 63.329 42.0306 64.1861C42.5324 65.7847 43.2373 67.3664 44.4158 68.559C44.6442 68.7902 44.943 69.0185 45.2588 68.9452C45.428 68.9058 45.5661 68.7845 45.6789 68.6548C46.1497 68.1079 46.2991 67.3551 46.3273 66.6333C46.3724 65.5112 46.0736 63.969 45.6338 62.9343C45.5013 62.6185 45.3236 62.2887 45.0135 62.1392C44.7936 62.5227 44.8725 63.0048 44.9797 63.4333C45.1094 63.9577 45.3659 64.8825 45.5576 65.3872C45.8057 66.0356 46.1187 66.6813 46.6346 67.1408C46.8094 67.2987 47.0378 67.4369 47.269 67.3889C47.5058 67.341 47.6581 67.1126 47.7539 66.8927C48.1994 65.8636 47.6045 63.9831 47.2972 62.9033C47.582 63.8619 48.1712 65.5281 48.6702 66.3965C48.8563 66.3937 48.9268 66.154 48.9437 65.9708C49.0029 65.3195 48.9832 64.203 48.9465 63.3882C49.282 63.907 49.3272 64.0395 49.705 64.5554C49.9925 64.953 50.297 65.3364 50.5846 65.5507C50.8722 65.765 51.2866 65.8665 51.5996 65.686"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M83.715 78.9708L78.8516 77.0988"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M48.959 48.1211L54.6795 52.0767L65.4552 39.1301"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M58.2109 76.4475L72.5954 73.552L73.2805 73.4364C76.9345 72.7343 79.2999 69.1678 78.5246 65.528L68.5609 21.2214C68.0675 18.8813 65.7753 17.3814 63.4353 17.8663L59.2005 18.7432"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M58.516 16.6512L52.0371 18.1258C51.6141 18.2216 51.1715 18.1483 50.8022 17.9228L49.6744 17.232C49.9592 16.4229 50.0015 15.5207 49.7393 14.6269C49.1359 12.58 47.0468 11.2859 44.9463 11.6581C42.5188 12.0895 40.9907 14.4634 41.5602 16.8232C41.7576 17.6465 42.1861 18.3541 42.7585 18.8983L42.1749 19.8569C41.9408 20.2403 41.563 20.511 41.126 20.6096L33.9761 22.2364C32.6341 22.5409 31.7911 23.8801 32.0984 25.2221C32.4029 26.5642 33.7421 27.4072 35.0841 27.0999L59.6268 21.5118C60.9689 21.2073 61.8119 19.8681 61.5045 18.5261C61.2001 17.1841 59.8608 16.3411 58.5188 16.6484L58.516 16.6512ZM45.3946 14.5226C45.95 14.3873 46.5111 14.7312 46.6436 15.2866C46.7789 15.8421 46.4349 16.4031 45.8795 16.5356C45.3241 16.671 44.763 16.327 44.6305 15.7716C44.4952 15.2162 44.8392 14.6551 45.3946 14.5226Z"
            class="primary-fill" />
        <path
            d="M68.1699 90.8545C68.2038 94.937 69.0496 98.1285 71.4066 101.856C73.7636 105.58 74.6235 105.989 74.9336 106.716C75.0182 106.914 75.4383 109.023 76.0022 111.986"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M58.395 69.6923C57.2785 71.1922 55.9618 72.5624 56.4411 73.318C56.9515 74.1187 57.9213 74.5782 57.9213 74.5782C57.9213 74.5782 58.2681 79.8449 58.5444 81.1023C58.8207 82.3597 59.3789 83.0674 60.0133 83.1435C60.6477 83.2168 61.7303 82.3287 61.7303 82.3287C61.7303 82.3287 63.2161 85.8219 64.8288 84.9649C66.4415 84.1078 66.4641 83.1182 66.4866 82.4218C66.5289 81.1953 65.2122 77.4315 65.2122 77.4315"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M88.5901 75.2887C88.7734 72.7175 88.8298 71.1499 88.8157 70.8172C88.7762 69.7148 87.7951 68.4151 87.2876 68.0288C86.7801 67.6426 84.9588 65.5816 83.8789 64.6625C82.8019 63.7462 77.9949 58.9109 76.8446 58.0257C75.6943 57.1404 74.2395 57.1545 73.4811 57.3913C72.7226 57.6281 66.2888 58.4711 65.2485 59.2577C64.2081 60.0443 60.6388 62.1617 59.8042 63.0329C59.4152 63.4389 59.3306 63.4896 59.3503 63.749"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M88.5978 97.7648C87.9437 95.2471 87.4334 93.079 87.4136 92.3882C87.3855 91.4071 87.7492 86.2363 88.1157 81.2009"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M61.7985 73.4337C61.7985 73.4337 59.3203 75.41 57.9219 74.5783"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M61.7344 82.3287C61.7344 82.3287 62.8283 81.2629 63.1553 80.1295C63.3499 79.4529 63.3189 77.9812 63.2625 76.907"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M64.4805 65.0939C64.4805 65.0939 65.814 64.8909 66.7529 64.1776C67.6946 63.4671 68.2049 63.0639 68.2049 63.0639C68.2049 63.0639 69.3834 63.4953 70.404 63.5573C71.4246 63.6193 73.1895 63.6785 73.1895 63.6785C73.1895 63.6785 74.6782 65.7198 75.4873 66.7432"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M75.0494 60.5913C75.0494 60.5913 74.1556 63.4586 73.1914 63.6814"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M68.8086 60.8196C68.8086 60.8196 69.3302 61.8515 68.1855 63.0864"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.1751 74.4852L71.2305 68.8464"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.2724 82.6332C98.3877 84.7872 99.0446 84.8803 99.0446 84.8803L99.8312 82.6981L100.618 80.5159C100.618 80.5159 97.7815 79.2754 93.7554 77.5865C87.1891 74.8348 85.4298 74.1807 85.4298 74.1807L84.4825 76.8056L83.5352 79.4304C83.5352 79.4304 85.9993 80.42 92.2696 82.6276L92.2724 82.6332Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M58.2394 64.2367L56.5591 63.5714L52.5527 63.8364L55.2396 66.8418L57.5684 67.7356"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M101.552 82.4882L100.973 84.0956C100.786 84.6154 100.212 84.8852 99.692 84.6978L99.1588 84.5057L100.416 81.0178L100.949 81.21C101.469 81.3973 101.739 81.971 101.551 82.4909L101.552 82.4882Z"
            class="primary-fill" />
        <path
            d="M75.1048 75.9993C72.6406 73.7015 70.5994 71.0766 69.232 69.1313C67.8308 67.138 65.8459 65.6268 63.5538 64.8035C62.8489 64.5498 62.1723 64.3158 61.6507 64.141C59.9478 63.5743 58.1095 63.4981 57.5316 65.9764C57.134 67.6793 58.3041 69.4414 59.7617 71.1443C60.9797 72.5681 62.3894 73.8199 63.9344 74.8828L64.408 75.2099C65.7614 76.1402 66.7932 77.4766 67.3007 79.0386C67.3064 79.0527 67.3092 79.0668 67.3148 79.0809C68.3862 82.4077 67.8956 85.8164 68.2311 92.5237"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
